import React from 'react';
import PropTypes from 'prop-types';
import Button from '@marvelapp/marvel-ui/button';

import ArrowIconRight from 'marketing-website/components/icons/ArrowRight';
import ArrowIconLeft from 'marketing-website/components/icons/ArrowLeft';

function ArrowButton({
  hover = 'blue',
  color = 'slate',
  isReversed = false,
  onClick,
}) {
  return (
    <Button
      kind="ghost"
      shape="rounded"
      hover={hover}
      isReversed={color === 'white'}
      color={color}
      icon={isReversed ? <ArrowIconLeft /> : <ArrowIconRight />}
      iconHover={color === 'white' ? 'extraDarkSmoke' : 'white'}
      iconColor={color === 'white' ? 'white' : 'slate'}
      onClick={onClick}
    />
  );
}

ArrowButton.propTypes = {
  color: PropTypes.oneOf(['slate', 'white']),
  isReversed: PropTypes.bool,
  onClick: PropTypes.func,
  hover: PropTypes.oneOf(['blue', 'slate', 'white']),
};

export default ArrowButton;



// WEBPACK FOOTER //
// ./src/components/commons/ArrowButton/index.js